import React, { ComponentProps, forwardRef, ReactElement, ReactNode, Ref } from 'react'

import { InputBox } from '@app/lib/layout/InputBox/InputBox'
import { MergeProps } from '@app/lib/types'

export type TextInputProps<V extends string = string> = MergeProps<
  ComponentProps<'input'>,
  {
    icon?: ReactNode
    value?: V
    placeholder?: string
    onChange: (value?: V) => void
    size?: 'sm' | 'md' | 'lg'
    color?: 'primary' | 'secondary' | 'neutral'
    variant?: 'ghost' | 'quiet' | 'outlined'
  }
>

export const TextInput = forwardRef(
  <V extends string = string>(
    {
      onChange,
      value,
      icon,
      size,
      color,
      variant,
      type = 'text',
      className,
      ...rest
    }: TextInputProps<V>,
    ref: Ref<HTMLInputElement>
  ) => {
    return (
      <InputBox
        icon={icon}
        size={size}
        color={color}
        variant={variant}
        className={className}
        control={
          <input
            {...rest}
            type={type}
            ref={ref}
            value={value || ''}
            onChange={(e) => onChange(e.target.value as V)}
          />
        }
      />
    )
  }
) as <V extends string = string>(
  p: TextInputProps<V> & { ref?: Ref<HTMLInputElement> }
) => ReactElement | null
